import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MessagesService } from 'src/app/services/message/messages.service';

@Component({
  selector: 'app-control-panel',
  templateUrl: './control-panel.component.html',
  styleUrls: ['./control-panel.component.less']
})
export class ControlPanelComponent implements OnInit, OnDestroy {

  constructor(private ngbActiveMod: NgbActiveModal, private admin: AdminService, private load: NgxSpinnerService,
    private router: Router, private msg: MessagesService) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  // logs out admin
  public logOut() {
    this.load.show();
    this.admin.loggingOut()
      .then(msg => {
        this.ngbActiveMod.close();
        this.load.hide();
        this.router.navigate(['login']);
      })
      .catch(error => {
        this.load.hide();
        this.msg.error(error);
      });
  }

  // closes the modal
  public closeModal() {
    this.ngbActiveMod.close({ task: 'close modal', success: true });
  }

}
